import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const SHADOW_SIZE = 2;
export const SELECTED_CELL_BOX_SHADOW = `0 0 0 ${SHADOW_SIZE}px ${token('color.border.focused', colors.B200)} inset`;

export const DEFAULT_ROW_HEIGHT = 40;
